import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import AccordionState from "@toolkit/Framework/Store/Toolkit/Components/Accordion/AccordionState";
import { AccordionAnchorModel } from "@toolkit/Framework/Store/Toolkit/Components/Accordion/AccordionTypes";
import { CreateAccordionAnchorParameter } from "@toolkit/Framework/Store/Toolkit/Components/Accordion/Handlers/CreateAccordionAnchor";
import { RemoveAccordionAnchorParameter } from "@toolkit/Framework/Store/Toolkit/Components/Accordion/Handlers/RemoveAccordionAnchor";
import { SetIsAccordionOpenHandlerProps } from "@toolkit/Framework/Store/Toolkit/Components/Accordion/Handlers/SetIsAccordionOpen";
import { Draft } from "immer";

const initialState: AccordionState = {
    anchors: [],
};

const actions = {
    "Toolkit/Components/Accordion/CreateAccordionAnchor": (
        draft: Draft<AccordionState>,
        action: CreateAccordionAnchorParameter,
    ) => {
        const anchor: AccordionAnchorModel = {
            id: action.id,
            isOpen: action.isOpen,
        };
        draft.anchors = [...draft.anchors, anchor];
    },
    "Toolkit/Components/Accordion/SetIsAccordionOpen": (
        draft: Draft<AccordionState>,
        action: SetIsAccordionOpenHandlerProps,
    ) => {
        draft.anchors = action.anchors;
    },
    "Toolkit/Components/Accordion/RemoveAccordionAnchor": (
        draft: Draft<AccordionState>,
        action: RemoveAccordionAnchorParameter,
    ) => {
        draft.anchors = draft.anchors.filter(x => x.id !== action.id);
    },
};

const reducer = createTypedReducerWithImmer(initialState, actions);
export type AccordionActions = Parameters<typeof reducer>[1];
export default reducer;
